module.exports = __webpack_public_path__ + "img/轮播左翻滚.b604d4b6.svg";